import dayjs from 'dayjs';

/**
 * Manage query string HL7 date parameters.
 */
export const hl7DateParams = ({ startDate, endDate, withTime = false }) => {
  const searchParams = new URLSearchParams({});

  const stringStartDate = startDate ? new Date(startDate).toISOString() : null;
  const stringEndDate = endDate ? new Date(endDate).toISOString() : null;
  const format = withTime ? 'YYYY-MM-DD[T]HH:mm' : 'YYYY-MM-DD';
  if (startDate) {
    searchParams.append('date', `ge${dayjs(stringStartDate).format(format)}`);
  }
  if (endDate) {
    searchParams.append('date', `le${dayjs(stringEndDate).format(format)}`);
  }
  return searchParams;
};
